import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { UsesItemRecord } from '#shared/cms/records'

type UsesItemValue = Omit<UsesItemRecord, '$type'>


export default /*@__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'New uses item - admin - Daniel Roe' })

async function save (value: UsesItemValue) {
  await $fetch('/api/admin/uses-items', { method: 'POST', body: value })
  await navigateTo('/admin/uses')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminUsesItemForm = _resolveComponent("AdminUsesItemForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "New uses item" }, {
    default: _withCtx(() => [
      _createVNode(_component_AdminUsesItemForm, {
        "submit-label": "Create",
        onSubmit: save
      })
    ]),
    _: 1
  }))
}
}

})